import { axiosInstance as Axios } from "@/main";

export default {
  state: {
    steps: [
      { id: 1, description: "Convênio", name: "convenio" },
      { id: 2, description: "Especialidade", name: "especialidade" },
      { id: 3, description: "Clínica", name: "clinica" },
      { id: 4, description: "Data e hora", name: "agendar" },
      { id: 5, description: "Profissional" },
      { id: 6, description: "Paciente", name: "paciente" },
      { id: 7, description: "Confirmação" }
    ],
    informacao: "",
    telemedicineMessage: "",
    loadingDate: false,
    actualStep: 1,
    healthPlans: [],
    specialitys: [],
    clinics: [],
    schedules: [],
    medics: [],
    reschedule: null,
    historyPage: null,
    selectedReturn: null,
    agendamento: {},
    finalizado_integracao_juno: false,
    anexado_comprovante: false,
    selected: JSON.parse(localStorage.getItem("selected0.2")) || [
      {id: 0, nome: null, stepId: 1}, // convenio
      {id: 1, nome: null, stepId: 2}, // especialidade
      {id: 2, nome: null, stepId: 3}, // clinica
      {id: 3, nome: null, stepId: 4}, // data e hora
      {id: 4, nome: null, stepId: 5}, // profissional
      {id: 5, nome: null, stepId: 6} // paciente
    ]
  },
  mutations: {
    set_reschedule(state, payload) {
      state.reschedule = payload;
    },
    set_selectedreturn(state, payload) {
      state.selectedReturn = payload;
    },
    set_actualstep(state, payload) {
      state.actualStep = payload;
    },
    set_health_plan(state, payload) {
      state.healthPlans = payload;
    },
    set_speciality(state, payload) {
      state.specialitys = payload;
    },
    set_selected(state, payload) {
      const selected = state.selected.map(it =>
        it.stepId === payload.stepId ? payload : it
      );
      state.selected = selected;
      localStorage.setItem("selected0.2", JSON.stringify(selected));
    },
    set_clinics(state, payload) {
      state.clinics = payload;
    },
    set_schedules(state, payload) {
      state.schedules = payload;
      state.loadingDate = false;
    },
    set_moreschedules(state, payload) {
      state.schedules = [
        ...state.schedules,
        ...payload.filter(it => state.schedules.every(s => s.date !== it.date))
      ];

      state.loadingDate = false;
    },
    set_loading(state, payload) {
      state.loadingDate = payload;
    },
    set_medics(state, payload) {
      state.medics = payload;
    },
    clear_selected(state) {
      state.selected = [
        {id: 0, nome: null, stepId: 1}, // convenio
        {id: 1, nome: null, stepId: 2}, // especialidade
        {id: 2, nome: null, stepId: 3}, // clinica
        {id: 3, nome: null, stepId: 4}, // data e hora
        {id: 4, nome: null, stepId: 5}, // profissional
        {id: 5, nome: null, stepId: 6} // paciente
      ];

      state.actualStep = 1;
      localStorage.setItem("selected0.2", JSON.stringify(state.selected));
    },
    set_history(state, payload) {
      state.historyPage = payload;
    },
    set_message(state, payload) {
      state.informacao = payload;
    },
    set_finalizado_integracao_juno(state, payload){
      state.finalizado_integracao_juno = payload;
    },
    set_anexado_comprovante(state, payload){
      state.anexado_comprovante = payload;
    },
    set_steps(state, payload) {
      state.steps = payload;
    },
    set_agendamento(state, payload) {
      state.agendamento = payload;
    },
    set_telemedicine_message(state, payload) {
      state.telemedicineMessage = payload
    },
    clear_agendamento(state) {
      state.agendamento = {};
    }
  },
  actions: {
    clear_agendamento(store) {
      store.commit("clear_agendamento");
    },
    set_telemedicina(store) {
      const step = store.state.steps;
      if (!step.find(it => it.id === 8)) {
        step.push({id: 8, description: "Pagamento"});
      }
      store.commit("set_steps", step);
    },
    async loadclinicifneeded(store, payload) {
      let url = `${payload.url}geral/clinicas/${
        store.state.selected.find(it => it.stepId === 3).id
      }`;

      if (
        !store.getters.clinicSpecific ||
        store.state.selected.find(it => it.stepId === 3).nome
      ) {
        return;
      }

      let result = await Axios.get(url, {
        headers: {
          "X-Organizacao-ID": payload.organizationId
        }
      });

      let data = result.data;
      data.stepId = 3;
      store.commit("set_selected", data);
    },
    set_reschedule(store, payload) {
      store.commit("set_reschedule", payload);
    },
    async load_history(store, payload) {
      try {
        let result = await Axios.get(
          `${payload.url}protected/me/agendamentos?page=${
            payload.page ? payload.page : "1"
          }&size=${payload.size ? payload.size : "20"}`,
          {
            headers: {
              Authorization: `Bearer ${store.getters.token}`
            }
          }
        );
        store.commit("set_history", result.data);
      } catch (e) {
        console.log(e);
      }
    },
    async load_healthplan(store, payload) {
      try {
        let result = await Axios.get(payload.url, {
          headers: {"X-Organizacao-ID": payload.params.organizationId},
          params: {
            ...(store.getters.clinicSpecific
              ? {
                clinica_id: store.state.selected.find(it => it.stepId === 3)
                  .id
              }
              : {}),
            ...(localStorage.getItem("telemedicina")
              ? {
                telemedicina: localStorage.getItem("telemedicina")
              }
              : {})
          }
        });
        store.commit("set_health_plan", result.data);
      } catch (e) {
        console.log(e);
      }
    },
    async load_telemedicine_message(store, payload) {
      try {
        let result = await Axios.get(payload.url, {
          headers: {"X-Organizacao-ID": payload.params.organizationId},
          params: { marcacao_id: payload.params.marcacaoId }
        });
        store.commit("set_telemedicine_message", result.data);
      } catch (e) {
        console.log(e);
      }
    },
    async load_speciality(store, payload) {
      try {
        let result = await Axios.get(payload.url, {
          params: {
            convenio_id: store.state.selected.find(it => it.stepId === 1).id,
            ...(store.getters.clinicSpecific
              ? {
                clinica_id: store.state.selected.find(it => it.stepId === 3)
                  .id
              }
              : {}),
            ...(localStorage.getItem("telemedicina") ?
              {
                telemedicina: localStorage.getItem("telemedicina")
              }
              : {})
          },
          headers: {"X-Organizacao-ID": payload.params.organizationId}
        });
        store.commit("set_speciality", result.data);
      } catch (e) {
        console.log(e);
      }
    },
    async load_clinics(store, payload) {
      try {
        let params = {};
        if (payload.type === "exame") {
          params = {
            convenio_id: store.state.selected.find(it => it.stepId === 1).id,
            procedimento_id: store.state.selected.find(it => it.stepId === 2).id
          };
        } else {
          params = {
            convenio_id: store.state.selected.find(it => it.stepId === 1).id,
            especialidade_id: store.state.selected.find(it => it.stepId === 2).id
          };
        }
        if (localStorage.getItem("telemedicina")) {
          params.telemedicina = localStorage.getItem("telemedicina");
        }

        let result = await Axios.get(payload.url, {
          params: params,
          headers: {"X-Organizacao-ID": payload.params.organizationId}
        });
        store.commit("set_clinics", result.data);
      } catch (e) {
        console.log(e);
      }
    },
    async load_moreschedules(store, payload) {

      const {data} = await Axios.get("agendamentos/agendas", {
        params: {
          convenio_id: store.state.selected.find(it => it.stepId === 1).id,
          [store.getters.type === "consulta"
            ? "especialidade_id"
            : "procedimento_id"]: store.state.selected.find(
            it => it.stepId === 2
          ).id,
          clinica_id: store.state.selected.find(it => it.stepId === 3).id,
          data_inicio: payload.date,
          telemedicina: localStorage.getItem("telemedicina")
        },
        headers: {"X-Organizacao-ID": payload.params.organizationId}
      });

      store.commit("set_schedules", [...store.state.schedules, ...data]);

    },
    async load_schedules(store, payload) {
      store.commit("set_schedules", []);
      
      let {data} = await Axios.get("agendamentos/agendas", {
        params: {
          convenio_id: store.state.selected.find(it => it.stepId === 1).id,
          [store.getters.type === "consulta"
            ? "especialidade_id"
            : "procedimento_id"]: store.state.selected.find(
            it => it.stepId === 2
          ).id,
          clinica_id: store.state.selected.find(it => it.stepId === 3).id,
          ...(localStorage.getItem("telemedicina")
              ? {telemedicina: localStorage.getItem("telemedicina")}
              : {}
          )
        },
        headers: {"X-Organizacao-ID": payload.params.organizationId}
      });

      store.commit("set_schedules", data);
    },
    async load_medics(store, payload) {
      try {
        let result = await Axios.get(payload.url, {
          params: {
            convenio_id: store.state.selected.find(it => it.stepId === 1).id,
            [store.getters.type === "consulta"
              ? "especialidade_id"
              : "procedimento_id"]: store.state.selected.find(
              it => it.stepId === 2
            ).id,
            clinica_id: store.state.selected.find(it => it.stepId === 3).id
          },
          headers: {"X-Organizacao-ID": payload.organizationId}
        });
        store.commit("set_medics", result.data);
      } catch (e) {
        console.log(e);
      }
    },
    async confirm_payment(store, payload) {
      store.commit("set_anexado_comprovante",false);
      await Axios.post(
        `${payload.url}protected/me/comprovante`,
        payload.data,
        {
          headers: {
            Authorization: `Bearer ${store.rootState.User.token}`,
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then((response) => {
        if (response.status === 200) {
          store.commit("set_anexado_comprovante",true);
        }
      });
    },
    reset_pagamento_juno(store){
      store.commit("set_finalizado_integracao_juno",false);
    },
    reset_anexado_comprovante(store){
      store.commit("set_anexado_comprovante",false);
    },
    async abrir_aba_pagamento_juno(store, payload) {
      store.commit("set_finalizado_integracao_juno",false);
      await Axios.get(
        `/juno?marcacao_id=${store.getters.get_agendamento.id}`, {
          headers: {
            Authorization: `Bearer ${store.rootState.User.token}`,
            "X-Organizacao-ID": payload.params.organizationId,
            "X-Token-Sessao": store.getters.session || ""
          }
        }).then((response) => {
          if (response.status === 200) {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
              window.location.href = response.data.checkoutUrl;
            } else {
              const win = window.open(response.data.checkoutUrl, '_blank');
              win.focus();
            }
            store.commit("set_finalizado_integracao_juno",true)
          }
      })
    },
    async confirm_schedule(store, payload) {
      try {
        store.commit("set_message", "");
        await Axios.post(
          `${payload.url}protected/me/agendamentos`,
          {
            horaAgendamento: store.getters.get_selected[3].date,
            dependenteId: store.getters.get_selected[5].dependente
              ? store.getters.get_selected[5].id
              : null,
            convenioId: store.getters.get_selected[0].id,
            agendaId: store.getters.get_selected[3].agendaId,
            ...(localStorage.getItem("telemedicina") ? {telemedicina: localStorage.getItem("telemedicina")} : {}),
            [store.getters.type === "consulta"
              ? "especialidadeId"
              : "procedimentoId"]: store.getters.get_selected[1].id
          },
          {
            headers: {
              Authorization: `Bearer ${store.rootState.User.token}`,
              "X-Organizacao-ID": payload.params.organizationId,
              "X-Token-Sessao": store.getters.session || ""
            }
          }
        ).then((response) => {
          if (response.status === 200) {
            store.commit("set_agendamento", response.data);
          }
        });
        if (!localStorage.getItem("telemedicina")) {
          store.commit("clear_selected");
        }
        store.commit("set_message", "sucesso");
      } catch (e) {
        store.commit("set_message", e.response ? e.response.data.message : e);
      }
    },
    load_selected(state, payload) {
      state.commit("set_selected", payload);
      state.dispatch("set_query");
    },
    set_loading(store, payload) {
      store.commit("set_loading", payload);
    },
    set_selectedreturn(store, payload) {
      store.commit("set_selectedreturn", payload);
    }
  },
  getters: {
    reschedule(state) {
      return state.reschedule;
    },
    get_agendamento(state) {
      return state.agendamento;
    },
    get_finalizado_integracao_juno(state) {
      return state.finalizado_integracao_juno;
    },
    get_anexado_comprovante(state) {
      return state.anexado_comprovante;
    },
    get_telemedicine_message(state) {
      return state.telemedicineMessage;
    },
    get_steps(state, _getters, rootState) {
      let steps = { ...state.steps };
      if (rootState.Path.type === "exame") {
        steps[1] = {
          ...steps[1],
          description: "Procedimento",
          name: "procedimento"
        };
      } else if (rootState.Path.type === "consulta") {
        steps[1] = {
          ...steps[1],
          description: "Especialidade",
          name: "especialidade"
        };
      }

      return steps;
    },
    get_actualStep(state) {
      return state.actualStep;
    },
    get_healthPlans(state, _getters, rootState) {
      return state.healthPlans.filter(item => {
        return (
          item.nome
            .toLowerCase()
            .indexOf(rootState.General.search.toLowerCase()) > -1
        );
      });
    },
    get_specialitys(state, _getters, rootState) {
      return state.specialitys.filter(item => {
        return (
          item.nome
            .toLowerCase()
            .indexOf(rootState.General.search.toLowerCase()) > -1
        );
      });
    },
    get_selected(state) {
      return state.selected;
    },
    get_clinics(state) {
      return state.clinics;
    },
    get_schedules(state, _getters, rootState) {
      return state.schedules.map(item => {
        return {
          ...item,
          profissionais: item.profissionais.filter(prof => {
            return (
              prof.nome
                .toLowerCase()
                .indexOf(rootState.General.search.toLowerCase()) > -1
            );
          })
        };
      });
    },
    get_loading(state) {
      return state.loadingDate;
    },
    medics(state, _getters, rootState) {
      if (state.selected.find(it => it.stepId === 4).medics) {
        return state.medics
          .filter(item =>
            state.selected
              .find(it => it.stepId === 4)
              .medics.some(it => it.profissionalId === item.id)
          )
          .filter(
            item =>
              item.nome
                .toLowerCase()
                .indexOf(rootState.General.search.toLowerCase()) > -1
          );
      } else {
        return null;
      }
    },
    historyPage(state) {
      return state.historyPage;
    },
    selected_return(state) {
      return state.selectedReturn;
    },
    message(state) {
      return state.informacao;
    }
  }
};
